export const formatPolicyNumber = (policyNumber: string) => {
  const match = policyNumber.match(/^(\d{7})SCP(\d{2})-(\d{2})$/);
  if (match) {
    return `${match[1]}-SCP-${match[2]}`;
  }
  return policyNumber;
};
